// Module
var code = "<template> <a class=\"crumb\" click.delegate=\"click({e: $event})\"> <slot></slot> </a> </template>";
// Exports
export default code;